<template>
  <div id="app">
    <LandingPage
      v-if="currentPage==='LandingPage'"
      @user-logged-in="handleGoogleSuccess"
    />
    <SignupPage
      v-if="currentPage === 'SignupPage'"
      :initialFullname="googleFullname"
      :initialEmail="googleEmail"
      :user="loggedInUser"
      @user-registered="handleUserRegistered"
      @change-page="changePage"
    />
    <KeepAlive>
      <DashboardPage
        v-if="currentPage === 'DashboardPage' && loggedInUser && loggedInUser.user_type"
        :user="loggedInUser"
        @change-page="changePage"
        @edit-pet="openEditPetPage" 
        @view-pet-profile="viewPetProfile"
        @profile-updated="user = $event"
      />
    </KeepAlive>
    <AddPetPage 
      v-if="currentPage === 'AddPetPage'" 
      :user="currentUser" 
      @change-page="changePage" 
    />
    <LoginPage 
      v-if="currentPage === 'LoginPage'" 
      @change-page="changePage" 
      @user-logged-in="loggedInUser = $event"
    />
    <WelcomePage 
      v-if="currentPage === 'WelcomePage'" 
      :user="loggedInUser"
      @change-page="changePage" 
    />
    <LogoutPage
      v-if="currentPage === 'LogoutPage'"
      :user="loggedInUser"
      @change-page="changePage"
    />
    <KeepAlive>
      <BrowsePetsPage
        v-if="currentPage === 'BrowsePetsPage'"
        :user="loggedInUser"
        @change-page="changePage"
        @view-pet-profile="viewPetProfile"
      />
    </KeepAlive>
    <EditPetDashboard 
      v-if="currentPage === 'EditPetDashboard'"
      :pet="selectedPet"
      :user="loggedInUser"
      @close="changePage('DashboardPage')"
      @changePage="changePage"
    />
    <BookPetAppointmentPage
      v-if="currentPage === 'BookPetAppointmentPage' && pageProps && pageProps.pet"
      :pet-id="pageProps.pet.id"
      :user="loggedInUser"
      @change-page="changePage"
      @close="changePage('DashboardPage')"
    />
    <MeetingsPage
      v-if="currentPage === 'MeetingsPage'"
      :user="loggedInUser"
      @change-page="changePage"
    />
    <CalendarPage
      v-if="currentPage === 'CalendarPage'"
      :user="loggedInUser"
      @change-page="changePage"
    />
    <PetRequestsPage
      v-if="currentPage==='PetRequestsPage'"
      :user="loggedInUser"
      @change-page="changePage"
    />
    <EditUserDashboard
      v-if="currentPage === 'EditUserDashboard'"
      :user="loggedInUser"
      :pets="userPets"
      @change-page="changePage"
    />
    <PetDescriptionPage
      v-if="currentPage === 'PetDescriptionPage'"
      :pet="pageProps.pet"
      :user="loggedInUser"
      @change-page="changePage"
      @close="changePage('DashboardPage')"
    />
    <UsersFavouritesPage
      v-if="currentPage === 'UsersFavouritesPage'"
      :user="loggedInUser"
      @view-pet-profile="viewPetProfile"
      @change-page="changePage"
    />
    <YourPetsPage 
      v-if="currentPage === 'YourPetsPage'" 
      :user="loggedInUser"
      @change-page="changePage" 
      @edit-pet="openEditPetPage"
    />
  </div>
</template>

<script>
import LandingPage from './components/LandingPage.vue';
import SignupPage from './components/SignupPage.vue';
import DashboardPage from './components/DashboardPage.vue';
import AddPetPage from './components/AddPetPage.vue';
import LoginPage from './components/LoginPage.vue';
import WelcomePage from './components/WelcomePage.vue';
import LogoutPage from './components/LogoutPage.vue';
import BrowsePetsPage from './components/BrowsePetsPage.vue';
import EditPetDashboard from './components/EditPetDashboard.vue';
import BookPetAppointmentPage from './components/BookPetAppointmentPage.vue';
import MeetingsPage from './components/MeetingsPage.vue';
import CalendarPage from './components/CalendarPage.vue';
import PetRequestsPage from './components/PetRequestsPage.vue';
import EditUserDashboard from './components/EditUserDashboard.vue';
import PetDescriptionPage from './components/PetDescriptionPage.vue';
import UsersFavouritesPage from './components/UsersFavouritesPage.vue';
import YourPetsPage from './components/YourPetsPage.vue';
import axios from 'axios';

const routeMap = {
  LandingPage:            '/',
  SignupPage:             '/signup',
  DashboardPage:          '/dashboard',
  AddPetPage:             '/add-pet',
  LoginPage:              '/login',
  WelcomePage:            '/welcome',
  LogoutPage:             '/logout',
  BrowsePetsPage:         '/browse',
  EditPetDashboard:       '/edit-pet',
  BookPetAppointmentPage: '/book',
  MeetingsPage:           '/meetings',
  CalendarPage:           '/calendar',
  PetRequestsPage:        '/requests',
  EditUserDashboard:      '/account',
  PetDescriptionPage:     '/pet',
  UsersFavouritesPage:    '/favourites',
  YourPetsPage:           '/my-pets',
};

export default {
  components: {
    LandingPage,
    SignupPage,
    DashboardPage,
    AddPetPage,
    LoginPage,
    WelcomePage,
    LogoutPage,
    BrowsePetsPage,
    EditPetDashboard,
    BookPetAppointmentPage,
    MeetingsPage,
    CalendarPage,
    UsersFavouritesPage,
    PetRequestsPage,
    EditUserDashboard,
    PetDescriptionPage,
    YourPetsPage
  },
  data() {
    return {
      currentPage: 'LandingPage',
      pageHistory: [],
      currentUser: null,
      selectedPet: null,
      loggedInUser: null,
      pageProps: {},
      userPets: [],
      googleFullname: '',
      googleEmail: '',
      editMode: false,
    };
  },
  methods: {
    viewPetProfile(pet) {
      this.changePage('PetDescriptionPage', { pet });
    },
    handleGoogleSuccess(payload) {
      console.log('✅ Google login response:', payload);
      this.loggedInUser = payload;
      this.currentUser = payload;
      if (payload.isNew || !payload.user_type) {
        this.changePage('SignupPage');
      } else {
        this.changePage('DashboardPage');
      }
    },
    onLogin(payload) {
      console.log('✅ onLogin payload:', payload);
      this.googleEmail =
        payload.email ||
        (payload.user && payload.user.email) ||
        '';
      this.googleFullname =
        payload.fullname ||
        (payload.user && payload.user.fullname) ||
        '';
      this.currentUser = payload;
      this.loggedInUser = payload;

      axios
        .get(`${process.env.VUE_APP_API_URL}/api/auth/users/email/${this.googleEmail}`, { withCredentials: true })
        .then(res => {
          this.loggedInUser = res.data.user;
          if (!this.loggedInUser?.user_type) {
            return this.changePage('SignupPage');
          }
          this.changePage('DashboardPage');
        })
        .catch(err => {
          console.error('Error fetching user by email:', err);
        });
    },
    changePage(page, props = {}) {
      this.pageHistory.push(this.currentPage);
      const path = routeMap[page] || '/';
      window.history.pushState({ page }, '', path);
      this.currentPage = page;
      this.pageProps = props;
      if (props.pet) this.selectedPet = props.pet;
    },
    handleBackButton() {
      if (this.pageHistory.length > 0) {
        const previousPage = this.pageHistory.pop();
        const path = routeMap[previousPage] || '/';
        window.history.pushState({ page: previousPage }, '', path);
        this.currentPage = previousPage;
        this.pageProps = {};
      } else {
        window.history.back();
      }
    },
    setUser(user) {
      this.currentUser = user;
      this.currentPage = 'DashboardPage';
    },
    openEditPetPage(pet) {
      this.selectedPet = pet;
      this.changePage('EditPetDashboard');
    },
    closePetDashboard() {
      this.selectedPet = null;
    },
    handleUserRegistered(user) {
      console.log('✅ handleUserRegistered got user:', user);
      this.loggedInUser = user;
      this.changePage('DashboardPage');
    },
  },
  mounted() {
    window.history.pushState({ page: this.currentPage }, '', routeMap[this.currentPage] || '/');
    window.addEventListener('popstate', this.handleBackButton);
  },
  beforeUnmount() {
    window.removeEventListener('popstate', this.handleBackButton);
  }
};
</script>